<template>
    <div>
        <div class="sga-page-8 page-8">
            <div>
                <h3>Technologies</h3>
                <p>
                    <strong>What technologies do you have experience using?</strong><br />
                </p>
                <el-form @submit.native.prevent>
                    <div id="" v-for="(
              technology, index
            ) in  currentSgaTechnologies.technologies " :key="index">
                        <TechnologyForm :technology="technology" class="technology-form" :showRemoveForm="index > 0"
                            @custom-technology-added="handleCustomTechnologyAdded(index)"
                            @custom-technology-removed="handleCustomTechnologyRemoved(index)"
                            @selection-made="handleSelectionMade(index)"
                            @technology-form-removed="removeTechnologyForm(index)" />
                    </div>

                    <el-row>
                        <el-col>
                            <button class="ts-btn ts-btn-white btn-add-technology" @click.prevent="addEmptyTechnology">
                                + Add another Technology
                            </button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <br />
            <button class="ts-btn ts-btn-rounded ts-btn-secondary" @click="storeSection()">
                Continue
            </button>
            <a class="back-link" href="/sga/questionnaire/7">
                <i class="fas fa-chevron-left"></i>Back
            </a>

            <el-alert v-if="technologyFormError" :title="technologyFormError" type="error" :closable="false"></el-alert>
            <TSLoading :active="isLoading" :defaultMessage="'Please wait...'"
                :altMessage="'Please hold on for a moment while we process the data...'" />
        </div>

        <questionnaire-print ref="questionnaire" :page1="page1" :page2="page2" :page3="page3" :page4="page4" :page5="page5"
            :page6="page6" :page7="page7" :page8="page8" :page9="page9" :page10="page10" :page11="page11" :page12="page12"
            currentPage="page8">
        </questionnaire-print>
        <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="String(base64Raw)"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
        <ResumeListSelection :ProfileSettings="profileSettings" :ShowControl="showResumeListModal"
            @close-control="closeResumeListModal" @show-resume="displayResume"></ResumeListSelection>
    </div>
</template>
  
<script>

import TechnologyForm from '../../components/TechnologyForm.vue';
import TSLoading from "@/components/TSLoading.vue";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";;
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {

    components: {
        TechnologyForm, TSLoading, QuestionnairePrint, JobSeekerCV,
        ResumeListSelection
    },
    created() {
        this.$store.dispatch("sga/getsga").then(() => {
            this.currentSgaTechnologies.technologies = [];
            if (this.currentSga.sgaTechnologies != null) {
                const { selectedTechnologies, customTechnologies } = this.currentSga.sgaTechnologies
                selectedTechnologies?.forEach(t => {
                    this.currentSgaTechnologies.technologies.push({
                        selection: t.selection,
                        custom: null,
                        isCustom: false,
                        yearsOfExperience: t.yearsOfExperience
                    })
                })
                customTechnologies?.forEach(t => {

                    this.currentSgaTechnologies.technologies.push({
                        selection: null,
                        custom: t.selection,
                        isCustom: true,
                        yearsOfExperience: t.yearsOfExperience
                    })
                })
            } else{
                this.currentSga.sgaTechnologies = {};
            }

            if (this.currentSgaTechnologies.technologies?.length === 0) {
                this.addEmptyTechnology();
            }
        });

        if (sessionStorage.getItem("profilephoto")) {
            this.base64Raw = sessionStorage.getItem("profilephoto");
        }

        this.$router.app.$on("questionnaire-print", this.printPage);
        this.$router.app.$on("show-resume-list", this.showResumeList);
    },
    destroyed() {
        if (
            this.$route.matched.find((c) => c.path === "/sga/questionnaire") ===
            undefined
        ) {
            sessionStorage.removeItem("sgaDataForPrinting");
        } else {
            this.$router.app.$off("questionnaire-print", this.printPage);
            this.$router.app.$off("cv-print", this.printPageAsCV);
        }
    },
    methods: {
        async filter(searchQuery) {
            this.$store.dispatch("onet/technologies", { searchQuery }).then((res) => {
                this.$store.dispatch(
                    "sga/setTechnologies",
                    res.map((v) => v.name)
                );
            });
        },
        handleCustomTechnologyAdded(index) {
            // Assuming you're adding the custom technology to the list
            const newTechnology = {
                selection: null,
                custom: this.currentSgaTechnologies.technologies[index].custom,
                isCustom: true,
                yearsOfExperience: this.currentSgaTechnologies.technologies[index].yearsOfExperience,
                selectionError: null,
            };
            this.$set(this.currentSgaTechnologies.technologies, index, newTechnology);
        },
        handleCustomTechnologyRemoved(index) {
            // Assuming you're removing the custom technology from the list
            const newTechnology = {
                selection: this.currentSgaTechnologies.technologies[index].selection,
                custom: null,
                isCustom: false,
                yearsOfExperience: this.currentSgaTechnologies.technologies[index].yearsOfExperience,
                selectionError: null,
            };
            this.$set(this.currentSgaTechnologies.technologies, index, newTechnology);
        },
        handleSelectionMade(index) {
            // Handle any additional logic when a selection is made
            const newTechnology = {
                selection: this.currentSgaTechnologies.technologies[index].selection,
                custom: null,
                yearsOfExperience: this.currentSgaTechnologies.technologies[index].yearsOfExperience,
                isCustom: false,
                selectionError: null,
            };
            this.$set(this.currentSgaTechnologies.technologies, index, newTechnology);
        },
        addEmptyTechnology() {
            this.currentSgaTechnologies.technologies.push({
                selection: null,
                custom: null,
                yearsOfExperience: null
            });
        },
        removeTechnologyForm(index) {
            this.currentSgaTechnologies.technologies.splice(index, 1)
        },
        validateSubmit() {
            const technologyWithValication = this.currentSgaTechnologies.technologies.map(t => {
                this.$set(t, 'selectionError', null);
                this.$set(t, 'customError', null);
                this.$set(t, 'yearsOfExperienceError', null);

                if (t.isCustom && t.custom == null) {
                    this.$set(t, 'customError', 'This field is required.');
                }

                if (!t.isCustom && t.selection == null) {
                    this.$set(t, 'selectionError', 'This field is required.');
                }

                if (t.yearsOfExperience == null) {
                    this.$set(t, 'yearsOfExperienceError', 'This field is required.');
                }

                return t;
            })

            this.$set(this.currentSgaTechnologies, 'technologies', technologyWithValication)

            return this.currentSgaTechnologies.technologies.every(t => t.selectionError === null && t.customError === null && t.yearsOfExperienceError === null)
        },
        storeSection() {
            this.isLoading = true;
            this.technologyFormError = null;
            if (this.currentSgaTechnologies.technologies.length == 0 || this.currentSgaTechnologies.technologies.every(x => x.selection == null || x.custom == null).length) {
                this.technologyFormError = "Please add at least 1 technology.";
                this.isLoading = false;
                return false;
            }

            if (!this.validateSubmit()) {

                this.isLoading = false;
                return false;
            }

            this.technologyFormError = null;

            const { selectedTechnologies, customTechnologies } = this.currentSgaTechnologies.technologies.reduce((acc, t) => {
                if (t.custom) {
                    acc.customTechnologies.push(t);
                } else {
                    acc.selectedTechnologies.push(t);
                }
                return acc;
            }, { selectedTechnologies: [], customTechnologies: [] });

            this.currentSga.sgaTechnologies.selectedTechnologies = selectedTechnologies.map(x => ({ id: x.id, selection: x.selection, yearsOfExperience: x.yearsOfExperience }));
            this.currentSga.sgaTechnologies.customTechnologies = customTechnologies.map(x => ({ id: x.id, selection: x.custom, yearsOfExperience: x.yearsOfExperience }));

            this.currentSga.sgaTechnologies.isComplete = true;

            if (this.currentSga.sgaTechnologies.id == null) {
                this.$store
                    .dispatch("sga/postsga", this.currentSga)
                    .then(() => {
                        this.$router.app.$emit("navigateToNextStep");
                    })
                    .catch((res) => {
                        this.modelState = res.errors;
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.$store
                    .dispatch("sga/putsga", this.currentSga)
                    .then(() => {
                        this.$router.app.$emit("navigateToNextStep");
                    })
                    .catch((res) => {
                        this.modelState = res.errors;
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
            sessionStorage.setItem(
                "sgaDataForPrinting",
                JSON.stringify({
                    page1: this.page1,
                    page2: this.page2,
                    page3: this.page3,
                    page4: this.page4,
                    page5: this.page5,
                    page6: this.page6,
                    page7: this.page7,
                    page8: { sgaTechnologies: this.currentSga.sgaTechnologies },
                })
            );
        },

        printPage(action) {
            this.loadPages(action);
        },
        loadPages(action) {
            this.$store.dispatch("sga/getsga").then((data) => {
                this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
                this.sgaEducation = data.sgaEducation || this.sgaEducation;
                this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
                this.sgaCertifications =
                    data.sgaCertifications || this.sgaCertifications;
                this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
                this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
                this.sgaMindset = data.sgaMindset || this.sgaMindset;
                this.sgaSkills = data.sgaSkills || this.sgaSkills;
                this.sgaHiddenTalents =
                    data.sgaHiddenTalents || this.sgaHiddenTalents;
                this.sgaCulture = data.culture || this.sgaCulture;
                this.sgaTechnologies = data.sgaTechnologies || this.sgaTechnologies;


                this.$store
                    .dispatch("sga/getSGAforPrint", this.sgaHiddenExtras)
                    .then(() => {
                        this.$refs.cv.hideCV();
                        this.$refs.questionnaire.showQuestionnaire();
                        action();
                        this.$refs.questionnaire.hideQuestionnaire();
                    });
            });
        },
        printPageAsCV(action) {
            this.cvCollection = [
                {
                    userInfo: this.currentUser,
                    image: this.base64Raw,
                    survey: this.currentSga,
                },
            ];
            this.$confirm("Do you want to include profile picture?", "Warning", {
                confirmButtonText: "Yes",
                dangerouslyUseHTMLString: true,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "No",
                center: true,
            })
                .then(() => {
                    this.showProfilePhoto = true;
                    this.$refs.cv.showCV(true);
                    this.$refs.questionnaire.hideQuestionnaire();
                    const x = this.$refs.cv.hideCV;
                    window.setTimeout(() => {
                        action();
                        x();
                    }, 500);
                })
                .catch(() => {
                    this.showProfilePhoto = false;
                    this.$refs.cv.showCV(false);
                    this.$refs.questionnaire.hideQuestionnaire();
                    const x = this.$refs.cv.hideCV;
                    window.setTimeout(() => {
                        action();
                        x();
                    }, 500);
                });
        },
        displayResume(setting) {
            const obj = {
                userid: this.currentUser.id,
                cvid: setting.id,
            };
            this.$store
                .dispatch("account/getprofiledetails", obj)
                .then((res) => {
                    this.profile = res;

                    this.showProfile =
                        this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
                    this.closeResumeListModal();

                    this.$refs.cv.showCV(true);
                    this.$refs.questionnaire.hideQuestionnaire();
                    const x = this.$refs.cv.hideCV;
                    window.setTimeout(() => {
                        window.print();
                        x();
                    }, 500);
                })
                .catch(() => { });
        },
        closeResumeListModal() {
            this.showResumeListModal = false;
        },
        showResumeList() {
            this.$store
                .dispatch("onlineprofile/getuserprofilepagesettings", this.currentUser.id)
                .then((res) => {
                    this.profileSettings = res.filter((d) => d.isActive == true);
                    this.loading = false;
                    this.showResumeListModal = true;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    computed: {
        currentSga() {
            return this.$store.state.sga.current_sga;
        },
        currentUser() {
            return this.$store.state.account.current_user;
        },
        page1() {
            return sessionStorage.getItem("sgaDataForPrinting")
                ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
                : {};
        },
        page2() {
            return {
                sgaYourJob: this.sgaYourJob,
                taskSearch: this.taskSearch,
                hiddenTasks: this.hiddenTasks,
            };
        },
        page3() {
            return {
                sgaEducation: this.sgaEducation,
            };
        },
        page4() {
            this.sgaWorkHistory.userWorkHistory.forEach((element) => {
                if (element.workedFrom == "0001-01-01T00:00:00") {
                    element.workedFrom = null;
                }
                if (element.workedTo == "0001-01-01T00:00:00") {
                    element.workedTo = null;
                }
            });
            return {
                sgaWorkHistory: this.sgaWorkHistory,
            };
        },
        page5() {
            this.sgaCertifications.userCertifications.forEach((element) => {
                if (element.acquiredDt == "0001-01-01T00:00:00") {
                    element.acquiredDt = null;
                }
                if (element.expirationDt == "0001-01-01T00:00:00") {
                    element.expirationDt = null;
                }
                if (element.image == undefined) {
                    element.image = null;
                }
            });
            return {
                sgaCertifications: this.sgaCertifications,
                selectedCodeDetail: this.selectedCodeDetail,
            };
        },
        page6() {
            return {
                sgaHiddenExtras: this.sgaHiddenExtras,
            };
        },
        page7() {
            return {
                sgaKnowledge: this.sgaKnowledge,
            };
        },
        page8() {
            return {
                sgaTechnologies: this.sgaTechnologies,
            };
        },
        page9() {
            return {
                sgaMindset: this.sgaMindset,
            };
        },
        page10() {
            return {
                sgaSkills: this.sgaSkills,
            };
        },
        page11() {
            return {
                sgaHiddenTalents: this.sgaHiddenTalents,
            };
        },
        page12() {
            return {
                sgaCulture: this.sgaCulture,
            };
        },
    },
    data() {
        return {
            currentSgaTechnologies: {
                technologies: [{
                    selection: null,
                    custom: null,
                    yearsOfExperience: null,
                    isCustom: false,
                    selectionError: null,
                    yearsOfExperienceError: null,
                    customError: null
                }],
            },
            technologyFormError: null,
            isLoading: false,
            modelState: {},
            profile: {},
            profileSettings: {},
            showProfile: true,
            showResumeListModal: false,
            base64Raw: {} | "",
            sgaYourJob: {
                jobRole: {},
                jobDescriptionTasks: [],
                customTasks: [],
            },
            sgaEmployeeInfo: {},
            sgaEducation: {
                secondLevelEducation: {
                    highSchoolDiploma: false,
                    ged: false,
                    oLevels: false,
                    oLevelDetails: [],
                    leavingCert: false,
                    aLevels: false,
                    aLevelDetails: [],
                },
                thirdLevelEducation: {
                    associateDegree: false,
                    associateDegreeDetails: [],
                    bachelorsDegree: false,
                    bachelorsDegreeDetails: [],
                },
                fourthLevelEducation: {
                    mastersDegree: false,
                    mastersDegreeDetails: [],
                    DoctoralDegree: false,
                    doctoralDegreeDetails: [],
                },
                sectorExperience: {
                    experience: false,
                    experienceDetails: [],
                },
                naicsLevel1Options: {},
            },
            sgaWorkHistory: {
                userWorkHistory: [],
            },
            sgaHiddenExtras: {
                workingPracticeActivities: [],
            },
            sgaKnowledge: {
                knowledgeRegularlyUsed: [],
            },
            sgaMindset: {
                mindsets: [],
            },
            sgaSkills: {
                workingPracticeSkills: [],
            },
            sgaTechnologies: {
                selectedTechnologies: [],
                customTechnologies: []
            },
            sgaHiddenTalents: {
                skillsKnowledgeOutsideWork: [],
            },
            sgaCulture: {
                selectedCultureOptions: [],
                commuteDistance: "",
                transportation: [],
            },
            sgaCertifications: {
                userCertifications: [],
            },
        }
    }
};
</script>
  
<style lang="scss">
button {
    text-align: left;
}


.technology-form {
    margin-top: 2rem;
}

.remove-icon {
    display: flex;
    justify-content: flex-end;
}
</style>
  